import { Box, Button, Container, Grid2, Typography } from "@mui/material";
import Background from "../../components/Background";
import MenteeHeader from "../../components/MenteeHeader";
import Mobilesidebar from "../../components/Mobilesidebar";
import Sidebar from "../../components/Sidebar";
import { useEffect, useState } from "react";
import { baseFetch } from "../../helpers/apiClient";
import WhiteStar from "../../assets/images/Star 2.svg";
import fightIconBg from "../../assets/images/flight-icon-with-bg.png";
import ContentRetentionInfoModal from "../../components/ContentRetentionInfoModal";
import PurchaseContentRetention from "./PurchaseContentRetention";
import DashboardFooter from "../../components/Footer";
import { useNavigate } from "react-router-dom";
import CancelRetentionModal from "../../components/CancelRetentionModal";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";

const EditContentRetention = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [retentionPlans, setRetentionPlans] = useState([]);
  const [suggestedRetentionPlan, setSuggestedRetentionPlan] = useState({});
  const [openLargeModal, setOpenLargeModal] = useState(false);
  const [openSmallModal, setOpenSmallModal] = useState(false);
  const [paymentMode, setPaymentMode] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [activePlan, setActivePlan] = useState(null);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isContentRetentionEnabled, setIsContentRetentionEnabled] =
    useState(false);
  const activePack = useSelector(
    (state) => state?.profileSlice?.profile?.purchaseInfo,
  );
  const navigate = useNavigate();
  useEffect(() => {
    const fetchRetentionPlans = async () => {
      setLoading(true);
      baseFetch({
        url: `/v1/web/retention/plans`,
        method: "GET",
      })
        .then((response) => {
          setRetentionPlans(response?.data?.allRetentionPlans?.prices || []);
          setSuggestedRetentionPlan(response?.data?.suggestedRetentionPrice);
          const foundItem = response?.data?.allRetentionPlans?.prices?.find(
            (item) =>
              item.id ===
              response?.data?.retentionPurchaseInfo?.subscriptionPlanPriceId,
          );
          if (foundItem) {
            setActivePlan(foundItem);
            setIsContentRetentionEnabled(true);
          }
        })
        .finally(() => setLoading(false));
    };
    fetchRetentionPlans();
  }, [paymentMode, isContentRetentionEnabled]);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handlePurchase = (plan) => {
    setSelectedPlan(plan);
    if (plan.unit_amount > suggestedRetentionPlan.unit_amount) {
      setOpenLargeModal(true);
    } else {
      setOpenSmallModal(true);
    }
  };
  const handleClose = () => {
    setOpenLargeModal(false);
    setOpenSmallModal(false);
  };

  const handleCancelRetention = () => {
    setLoading(true);
    baseFetch({
      url: `/v1/web/retention/cancel`,
      method: "POST",
    })
      .then(() => {
        setOpenCancelModal(false);
        setActivePlan(null);
        setIsContentRetentionEnabled(false);
      })
      .catch(console.log)
      .finally(() => setLoading(false));
  };

  const showBuyButtons = !activePack && !activePlan;
  const showRecommendedAsActive =
    activePack &&
    !activePlan &&
    retentionPlans.length &&
    suggestedRetentionPlan;
  const showActiveWithCancel = activePlan?.isActive && !activePack?.isActive;

  return (
    <>
      <Background>
        {loading && <Loader />}
        <MenteeHeader
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
        />
        <Box
          sx={{
            padding: {
              xs: "10px 0 20px",
              sm: "10px 0 20px",
              md: "10px 0 20px",
              lg: "10px 0 20px",
              xl: "20px 0 30px",
            },
          }}
        >
          <Container maxWidth="xl">
            <Grid2 container spacing={{ lg: 3, sm: 2, xs: 2 }}>
              <Grid2 item size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                <Mobilesidebar />
                <Sidebar />
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 8, md: 8, lg: 9 }}
                sx={{ flexGrow: 1 }}
              >
                <Box
                  sx={{
                    maxHeight: {
                      xs: "calc(100vh - 180px)",
                      sm: "calc(100vh - 100px)",
                      md: "calc(100vh - 100px)",
                      lg: "calc(100vh - 140px)",
                    },
                    overflowY: "auto",
                  }}
                >
                  {!paymentMode && (
                    <Box
                      sx={{
                        overflow: "none",
                        padding: "12px 24px",
                        borderRadius: "20px",
                        backgroundColor: "#fff",
                        boxShadow: "0px 20px 20px 0px #2A487610",
                        textAlign: "left",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "20px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            textAlign: "left",
                            fontFamily: "PT Sans",
                            marginBottom: "8px",
                            fontWeight: "bold",
                            color: "#2A4876",
                            fontSize: {
                              xs: "20px",
                              sm: "24px",
                              md: "26px",
                              lg: "28px",
                              xl: "32px",
                            },
                            margin: 0,
                          }}
                        >
                          Content Retention
                        </Typography>
                        {!isContentRetentionEnabled && !activePack && (
                          <Box
                            sx={{
                              backgroundColor: "#FF000017",
                              color: "#FF0000B2",
                              fontWeight: "bold",
                              padding: "5px 10px",
                              borderRadius: "6px",
                              height: "28px",
                              fontSize: {
                                xs: "10px",
                                sm: "14px",
                                md: "16px",
                                lg: "16px",
                                xl: "18px",
                              },
                            }}
                          >
                            No Content Retention Plan Active!
                          </Box>
                        )}
                      </Box>
                      <Typography
                        sx={{
                          color: "#000000B2",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                          marginBottom: "20px",
                        }}
                      >
                        Even if you choose not to renew your Corporate Account
                        subscription, you can still keep your content visible to
                        Echo’s community of aviation professionals through our
                        Content Retention Plan. Once your subscription ends,
                        your monthly retention plan will start automatically
                        based on the size of your content library and will
                        ensure your posts continue to reach and inspire industry
                        professionals every month.
                      </Typography>

                      {/* Show Buy Buttons */}
                      {showBuyButtons &&
                        retentionPlans?.map((plan) =>
                          plan.nickname !== suggestedRetentionPlan.nickname ? (
                            <Box
                              key={plan.id}
                              sx={{
                                padding: "12px",
                                backgroundColor: "#F1F7FA",
                                borderRadius: "16px",
                                marginBottom: "12px",
                                width: { xs: "100%", md: "70%", lg: "70%" },
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                color: "#2A4876",
                              }}
                            >
                              <Box sx={{ display: "flex", gap: "10px" }}>
                                <img
                                  src={fightIconBg}
                                  style={{ width: "21px", height: "21px" }}
                                />
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    fontSize: {
                                      xs: "14px",
                                      sm: "14px",
                                      md: "16px",
                                      lg: "16px",
                                      xl: "18px",
                                    },
                                  }}
                                >
                                  {plan.nickname} (
                                  {plan.contentSize.min === 0
                                    ? 1
                                    : plan.contentSize.min === 16
                                      ? "16+"
                                      : plan.contentSize.min}{" "}
                                  {plan.contentSize.max && "-"}{" "}
                                  {plan.contentSize.max} pieces) : $
                                  {plan.unit_amount / 100} / month
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                sx={{
                                  color: "#2A4876",
                                  fontWeight: "bold",
                                  borderRadius: "20px",
                                  textTransform: "capitalize",
                                  borderColor: "#2A4876",
                                }}
                                onClick={() => handlePurchase(plan)}
                              >
                                Buy
                              </Button>
                            </Box>
                          ) : (
                            <Box
                              key={plan.id}
                              sx={{
                                padding: "12px",
                                backgroundColor: "#F1F7FA",
                                borderRadius: "16px",
                                marginBottom: "12px",
                                width: { xs: "100%", md: "70%", lg: "70%" },
                                color: "#2A4876",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "10px",
                                }}
                              >
                                <Box sx={{ display: "flex", gap: "10px" }}>
                                  <img
                                    src={fightIconBg}
                                    style={{ width: "21px", height: "21px" }}
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: {
                                        xs: "14px",
                                        sm: "14px",
                                        md: "16px",
                                        lg: "16px",
                                        xl: "18px",
                                      },
                                    }}
                                  >
                                    {plan.nickname} (
                                    {plan.contentSize.min === 0
                                      ? 1
                                      : plan.contentSize.min === 16
                                        ? "16+"
                                        : plan.contentSize.min}{" "}
                                    {plan.contentSize.max && "-"}{" "}
                                    {plan.contentSize.max} pieces) : $
                                    {plan.unit_amount / 100} / month
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "4px",
                                    backgroundColor: "#42C66C",
                                    padding: "3px 10px",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <img src={WhiteStar} />
                                  <Typography
                                    sx={{
                                      color: "white",
                                      fontSize: {
                                        xs: "12px",
                                        sm: "13px",
                                        md: "13px",
                                        lg: "14px",
                                        xl: "16px",
                                      },
                                    }}
                                  >
                                    Recommended
                                  </Typography>
                                </Box>
                              </Box>
                              <hr />
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: "#000000B2",
                                    fontSize: {
                                      xs: "14px",
                                      sm: "14px",
                                      md: "16px",
                                      lg: "16px",
                                      xl: "18px",
                                    },
                                    marginRight: "10px",
                                  }}
                                >
                                  Based on your current content library, you’ll
                                  be charged{" "}
                                  <span
                                    style={{
                                      color: "#000000B2",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    $ {plan.unit_amount / 100} per month
                                  </span>{" "}
                                  for content retention in the{" "}
                                  <span
                                    style={{
                                      color: "#000000B2",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {plan.nickname} tier.
                                  </span>{" "}
                                </Typography>
                                <Button
                                  variant="contained"
                                  sx={{
                                    color: "white",
                                    fontWeight: "bold",
                                    borderRadius: "20px",
                                    backgroundColor: "#2A4876",
                                    textTransform: "capitalize",
                                    padding: "5px 20px",
                                    fontSize: {
                                      xs: "14px",
                                      sm: "14px",
                                      md: "16px",
                                      lg: "16px",
                                      xl: "18px",
                                    },
                                  }}
                                  onClick={() => {
                                    setSelectedPlan(plan);
                                    setPaymentMode(true);
                                  }}
                                >
                                  Buy
                                </Button>
                              </Box>
                            </Box>
                          ),
                        )}

                      {/* Recommended → Active badge when activePack exists but no activePlan */}
                      {showRecommendedAsActive && (
                        <Box
                          sx={{
                            padding: "12px",
                            backgroundColor: "#F1F7FA",
                            borderRadius: "16px",
                            marginBottom: "12px",
                            width: { xs: "100%", md: "70%", lg: "70%" },
                            color: "#2A4876",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box sx={{ display: "flex", gap: "10px" }}>
                              <img
                                src={fightIconBg}
                                style={{ width: "21px", height: "21px" }}
                              />
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: {
                                    xs: "14px",
                                    sm: "14px",
                                    md: "16px",
                                    lg: "16px",
                                    xl: "18px",
                                  },
                                }}
                              >
                                {suggestedRetentionPlan.nickname} (
                                {suggestedRetentionPlan.contentSize.min === 0
                                  ? 1
                                  : suggestedRetentionPlan.contentSize.min ===
                                      16
                                    ? "16+"
                                    : suggestedRetentionPlan.contentSize
                                        .min}{" "}
                                {suggestedRetentionPlan.contentSize.max && "-"}{" "}
                                {suggestedRetentionPlan.contentSize.max} pieces)
                                : ${suggestedRetentionPlan.unit_amount / 100} /
                                month
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "4px",
                                backgroundColor: "#42C66C",
                                padding: "3px 10px",
                                borderRadius: "8px",
                              }}
                            >
                              <img src={WhiteStar} />
                              <Typography
                                sx={{
                                  color: "white",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "13px",
                                    lg: "14px",
                                    xl: "16px",
                                  },
                                }}
                              >
                                Active
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      )}

                      {/* Active Plan with Cancel */}
                      {showActiveWithCancel && (
                        <Box
                          sx={{
                            padding: "10px",
                            borderRadius: "10px",
                            marginTop: "16px",
                            marginBottom: "15px",
                            width: "45vw",
                            color: "#2A4876",
                            border: "1px solid grey",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={fightIconBg}
                              style={{ width: "21px", height: "21px" }}
                            />
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                fontSize: {
                                  xs: "14px",
                                  sm: "14px",
                                  md: "16px",
                                  lg: "16px",
                                  xl: "18px",
                                },
                              }}
                            >
                              {activePlan?.nickname} (
                              {activePlan?.contentSize?.min === 0
                                ? 1
                                : activePlan?.contentSize?.min === 16
                                  ? "16+"
                                  : activePlan?.contentSize?.min}{" "}
                              {activePlan.contentSize.max && "-"}{" "}
                              {activePlan?.contentSize?.max} pieces) - $
                              {activePlan?.unit_amount / 100} / month
                            </Typography>
                            <Box sx={{ display: "flex", gap: "10px" }}>
                              <Typography
                                sx={{
                                  color: "white",
                                  backgroundColor: "#42C66C",
                                  padding: "5px",
                                  borderRadius: "8px",
                                }}
                              >
                                Active
                              </Typography>
                              {activePlan?.subscribeType !=
                                "introductory_offer" && (
                                <Button
                                  variant="outlined"
                                  sx={{
                                    color: "red",
                                    borderRadius: "25px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() => setOpenCancelModal(true)}
                                >
                                  Cancel Plan
                                </Button>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      )}

                      {(activePack?.isActive || activePlan?.isActive) && (
                        <>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "17px",
                            }}
                          >
                            Explore other Content Retention plans
                          </Typography>
                          {retentionPlans?.map(
                            (plan) =>
                              plan.id !== activePlan?.id &&
                              plan.id !== suggestedRetentionPlan?.id && (
                                <Box
                                  key={plan.id}
                                  sx={{
                                    padding: "16px",
                                    backgroundColor: "#F1F7FA",
                                    borderRadius: "10px",
                                    marginTop: "16px",
                                    marginBottom: "15px",
                                    width: "45vw",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#2A4876",
                                  }}
                                >
                                  <img
                                    src={fightIconBg}
                                    style={{ width: "21px", height: "21px" }}
                                  />
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      ml: 1.2,
                                      fontSize: {
                                        xs: "14px",
                                        sm: "14px",
                                        md: "16px",
                                        lg: "16px",
                                        xl: "18px",
                                      },
                                    }}
                                  >
                                    {plan.nickname} (
                                    {plan.contentSize.min === 0
                                      ? 1
                                      : plan.contentSize.min === 16
                                        ? "16+"
                                        : plan.contentSize.min}{" "}
                                    {plan.contentSize.max && "-"}{" "}
                                    {plan.contentSize.max} pieces) : $
                                    {plan.unit_amount / 100} / month
                                  </Typography>
                                </Box>
                              ),
                          )}
                        </>
                      )}
                      {/* Original notes, list items and manage content button unchanged */}
                      <Typography
                        sx={{
                          color: "#000000B2",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                        }}
                      >
                        Thank you for contributing to the echo community and
                        inspiring others with your content!
                      </Typography>
                      <br />
                      <hr />
                      <br />
                      <Typography
                        sx={{
                          color: "#000000B2",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                          fontStyle: "italic",
                          fontWeight: "bold",
                        }}
                      >
                        You can manage your content retention fees by:
                      </Typography>
                      <li
                        style={{
                          color: "#000000B2",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                        }}
                      >
                        Deleting content as needed to fit a lower pricing tier.
                      </li>
                      <li
                        style={{
                          color: "#000000B2",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                        }}
                      >
                        Cancelling Content Retention by deleting all your
                        content.{" "}
                        <b>Once you delete content, it cannot be recovered</b>.
                      </li>
                      <Typography
                        sx={{
                          color: "#000000",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                          marginTop: "20px",
                        }}
                      >
                        <b>Note:</b>
                      </Typography>
                      <Typography
                        sx={{
                          color: "#000000B2",
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "16px",
                            lg: "16px",
                            xl: "18px",
                          },
                          marginBottom: "24px",
                        }}
                      >
                        Content retention fees will be automatically charged to
                        the credit card on file. Once fees are charged, they are
                        <span style={{ fontWeight: "bold" }}>
                          {" "}
                          non-refundable.
                        </span>
                      </Typography>
                      <Button
                        className="text-white"
                        variant="contained"
                        sx={{
                          backgroundColor: "#2A4876",
                          "&:disabled": { backgroundColor: "#AAB6C8" },
                          fontWeight: 700,
                          fontSize: "18px",
                          width: { xs: "100%", sm: "70%", md: "370px" },
                          height: {
                            xs: "40px",
                            sm: "50px",
                            md: "60px",
                            lg: "70px",
                            xl: "70px",
                          },
                          borderRadius: "100px",
                          textTransform: "none",
                        }}
                        onClick={() =>
                          navigate("/profile/manage-content-retention")
                        }
                      >
                        Manage Content
                      </Button>
                    </Box>
                  )}
                  {paymentMode && (
                    <PurchaseContentRetention
                      suggestedRetentionPlan={suggestedRetentionPlan}
                      setPaymentMode={setPaymentMode}
                      selectedPlan={selectedPlan}
                    />
                  )}
                </Box>
              </Grid2>
            </Grid2>
            {openLargeModal && (
              <ContentRetentionInfoModal
                open={openLargeModal}
                large={true}
                handleClose={handleClose}
                setPaymentMode={setPaymentMode}
              />
            )}
            {openSmallModal && (
              <ContentRetentionInfoModal
                large={false}
                open={openSmallModal}
                handleClose={handleClose}
              />
            )}
            <CancelRetentionModal
              open={openCancelModal}
              handleClose={() => setOpenCancelModal(false)}
              handleConfirm={handleCancelRetention}
            />
          </Container>
        </Box>
      </Background>
      <DashboardFooter />
    </>
  );
};

export default EditContentRetention;
